// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root___tLS2","content":"LayoutSettings_content__iS81y"};